import { render, staticRenderFns } from "./ReportTransactional.vue?vue&type=template&id=0a1a4790"
import script from "./ReportTransactional.vue?vue&type=script&lang=js"
export * from "./ReportTransactional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports